import { useDevice } from '../../hooks';
import { MembershipModel } from '../../models';
import { Button, Modal } from '../ui';
import './ActivateMembershipRewardModal.css';

export function ActivateMembershipRewardModal(props: {
   isOpen: boolean;
   onClose: () => void;
   membership: MembershipModel;
   icon: string;
   onSubmit: () => void;
   isLoading: boolean;
}) {
   const { isOpen, onClose, membership, icon, onSubmit, isLoading } = props;
   const { isMobile } = useDevice();

   return (
      <Modal
         className="add-referral-modal"
         onClose={onClose}
         active={isOpen}
         darkBackground>
         <div className="flex flex-col gap-3 items-center">
            <h3>Claim {membership.name}</h3>
            <img
               src={icon}
               alt=""
               className="share-icon"
               width={isMobile ? 70 : 80}
            />
            <span className="green">1 free month</span>

            <Button
               title="Activate now"
               type="white-big"
               onClick={onSubmit}
               loading={isLoading}
               disabled={process.env.REACT_APP_ALLOW_REFERRAL_MEMBERSHIP_REWARD_ACTIVATION != 'true' || isLoading}
            />
            {process.env.REACT_APP_ALLOW_REFERRAL_MEMBERSHIP_REWARD_ACTIVATION != 'true' && <span className="red small">Memberships are not redeemable yet.</span>}
         </div>
      </Modal>
   );
}
